import { useEffect, useState } from "react";

export function formatOtpTime(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${String(minutes).padStart(2, "0")}:${String(remainingSeconds).padStart(2, "0")}`;
}

export function useOtpTimer() {
  const [timeLeft, setTimeLeft] = useState(0);
  const canResend = timeLeft <= 0;

  useEffect(() => {
    if (timeLeft <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const startTimer = (seconds: number) => {
    setTimeLeft(seconds);
  };

  return { timeLeft, canResend, startTimer, formatTime: formatOtpTime };
}
